<div class="smart-alert-backdrop" *ngIf="visible">
    <section class="smart-alert-modal" role="dialog" aria-modal="true" aria-labelledby="smart-alert-title">
        <header class="modal-header">
            <h2 id="smart-alert-title">SMART ALERTS</h2>

            <div class="header-right">
                <span class="active-count">
                    <span class="active-dot"></span>
                    {{ totalCount }} Active
                </span>

                <button type="button" class="close-button" aria-label="Close Smart Alerts" [disabled]="saving"
                    (click)="close()">
                    &times;
                </button>
            </div>
        </header>

        <div class="modal-content">
            <div *ngIf="errorMessage" class="error-message" role="alert">
                {{ errorMessage }}
                <button type="button" (click)="loadAlerts()">Retry</button>
            </div>

            <div *ngIf="loading" class="loading-message">
                Loading delayed activities...
            </div>

            <ng-container *ngIf="!loading">

                <article class="activity-card" *ngFor="
    let alert of alerts;
    trackBy: trackAlert
">
                    <div class="activity-heading">
                        <h3>{{ alert.message }}</h3>

                        <div class="activity-heading-right">
                            <span class="pending-count">
                                {{ alert.count }} orders
                            </span>

                            <button type="button" class="details-button" (click)="alert.expanded = !alert.expanded">
                                {{ alert.expanded ? 'Hide' : 'Details' }}
                            </button>
                        </div>
                    </div>

                    <div class="activity-details" *ngIf="alert.expanded">
                        <div class="table-wrapper">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Style</th>
                                        <th>Plan End Date</th>
                                        <th>Buyer</th>
                                        <th>Merchant</th>
                                        <th class="remark-column">Activity Remark</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr *ngFor="
                        let detail of alert.details;
                        trackBy: trackDetail
                    ">
                                        <td>
                                            {{ detail.style_code || detail.style_name || '-' }}
                                        </td>
                                        <td>{{ detail.plan_end_date || '-' }}</td>
                                        <td>{{ detail.buyer || '-' }}</td>
                                        <td>{{ detail.merchant || '-' }}</td>
                                        <td>
                                            <textarea [(ngModel)]="detail.remark" rows="2" maxlength="2000"
                                                placeholder="Enter remark..." [disabled]="saving" [attr.aria-label]="
                                    'Remark for ' + (detail.style_code || detail.cbr_id)
                                ">
                            </textarea>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </article>


                <div *ngIf="!alerts.length" class="empty-message">
                    No delayed activities found.
                </div>
            </ng-container>
        </div>

        <footer class="modal-footer">
            <label for="overall-remark">Overall Remark</label>

            <textarea id="overall-remark" [(ngModel)]="overallRemark" rows="2" maxlength="5000"
                placeholder="Enter overall remark..." [disabled]="saving"></textarea>

            <div class="footer-actions">
                <button type="button" class="cancel-button" [disabled]="saving" (click)="close()">
                    Close
                </button>

                <button type="button" class="save-button" [disabled]="saving || loading" (click)="save()">
                    {{ saving ? 'Saving...' : 'Save' }}
                </button>
            </div>
        </footer>
    </section>
</div>
